export default function Newsletters(){
    return(
        <div className="newsletter">
            <br />
            <form id="newsletter" method="POST">

                <div>
                    <label for="">Name: </label><br />
                    <input type="text" id="fn" name="fn" />
                </div>

                <div>
                    <label>Email:</label><br />
                    <input type="text" id="eml" name="eml" />
                </div>
                <br />
                <div>
                    <input type="submit" id="submit" name="submit" value=" Subscribe " style={{height: "40px", padding: "10px", backgroundColor: "blue", color: "white", fontWeight:"600"}} />
                </div>

            </form>
        </div>
    );
}